import { LoadingDirectiveModule } from '@shared/loading-directive/loading-directive.module';
import { NgModule } from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { FuseNavigationModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { NavbarHorizontalStyle1Component } from '@app/components-fuse/layout/components/navbar/horizontal/style-1/style-1.component';
import {TranslateModule} from '@ngx-translate/core';
import {MatMenuModule} from '@angular/material/menu';
import {InbeCommonsModule} from '@app/components/_common/inbe-commons.module';
import {LanguageSelectorComponent} from "../../../../../../../@shared/language-selector/language-selector.component";

@NgModule({
    declarations: [
        NavbarHorizontalStyle1Component
    ],
    imports: [
        MatButtonModule,
        MatIconModule,
        FuseSharedModule,
        FuseNavigationModule,
        TranslateModule,
        MatMenuModule,
        InbeCommonsModule,
        LanguageSelectorComponent,
        LoadingDirectiveModule,
    ],
    exports     : [
        NavbarHorizontalStyle1Component
    ]
})
export class NavbarHorizontalStyle1Module
{
}
